import {JsToClientInterface} from '../jsToClientInterface';
import consoleLogger from '../../logger/consoleLogger';
import {JsToClientCommand} from '../jsToClientCommand';
import { UnityBrowserApiMethods, UnityObjectNames } from "../../types/client";

const logger = consoleLogger.getPrefixedCopy('JS_TO_WEBGL');

export class JsWebglInterface implements JsToClientInterface {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public sendCommand<T>(command: JsToClientCommand<any>): T {
        let result: T;
        const wrappedCommand = {
            method: command.getName(),
            params: command.getParams()
        };

        logger.debug(JSON.stringify(wrappedCommand));

        if (!window.gameInstance || !window.gameInstance.SendMessage) {
            logger.error('Game instance or SendMessage method is not available.');
            return null;
        }

        // eslint-disable-next-line new-cap
        result = window.gameInstance.SendMessage(
            UnityObjectNames.UnityBrowserApi,
            UnityBrowserApiMethods.Receive,
            JSON.stringify(wrappedCommand)
        );

        logger.info(`Called command ${command.getName()}`);

        return result;
    }

    public openAccountWindow(): void {
        window.gameInstance.SendMessage(
            UnityObjectNames.UnityBrowserApi,
            UnityBrowserApiMethods.OpenAccountWindow
        );
    }
}
